<template>
  <div class="Risk">
    <!-- 当前位置 -->
    <div class="box">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <span class="dangqian">当前位置：</span>
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <div class="red">关于我们</div>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 布局容器 -->
    <div class="container">
      <!-- 左侧 -->
      <div class="left">
        <div class="top">
          <i class="iconfont iconbianzu10beifen3"></i>
          <p class="yi">关于我们</p>
        </div>

        <div
          class="smallBox"
          v-for="item in tabList"
          :key="item.id"
          :class="{ isActive: item.id == activeId }"
          @click="handle(item.id)"
        >
          {{ item.job }}
        </div>
      </div>
      <!-- 右侧 -->
      <div class="right">
        <div>
          <el-amap
            vid="amap"
            class="amap-demo"
            :center="center"
            zoom="16"
            :plugin="plugin"
          >
            <el-amap-marker vid="marker" :center="center"></el-amap-marker>
          </el-amap>
        </div>
        <!-- <span class="text">联系我们</span> -->
        <div class="textContent">
          <el-descriptions title="联系我们">
            <el-descriptions-item
              v-for="(item, index) in companyInfos"
              :key="index"
              :label="item.key"
              >{{ item.value }}</el-descriptions-item
            >
          </el-descriptions>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      companyInfos: [],
      center: [112.410389, 34.597277],
      plugin: ["AMap.ToolBar"],
      activeId: 1,
      tabList: [
        {
          id: 1,
          job: "公司简介",
        },
        {
          id: 2,
          job: "资质荣誉",
        },
        {
          id: 3,
          job: "组织架构",
        },
      ],
      areShow: true,
    };
  },
  created() {
    this.initFun();
  },
  methods: {
    handle(id) {
      if (id == 1) {
        this.activeId = 1;
        this.$router.push({
          name: "CompanyIntro",
        });
      } else if (id == 2) {
        this.activeId = 2;
        this.$router.push({
          name: "forumOutside",
        });
      } else if (id == 3) {
        this.activeId = 3;
        this.$router.push({
          name: "forumWarning",
        });
      }
    },

    initFun() {
      this.Api.SearchContactUsApi().then((res) => {
        let companyInfo = res.Data[0];
        let j = 0;
        for (let i = 0; i < 8; i++) {
          j++;
          let key = "key" + j;
          let value = "value" + j;
          if (companyInfo[key] == "") {
            break;
          } else {
            let obj = {};
            obj.key = companyInfo[key];
            obj.value = companyInfo[value];
            this.companyInfos.push(obj);
          }
        }
      });
    },
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.amap-demo {
  height: 300px;
}

.Risk {
  background: #f2f2f2;
  width: 1200px;
  margin: 0 auto;
  margin-bottom: 40px;
}
.container {
  width: 1200px;
  height: 100%;
  display: flex;
  justify-content: flex-end;
  margin: 0 auto;
  margin-top: 20px;
}
.box {
  margin-top: 15px;
  width: 100%;
  height: 12px;
}
/deep/ .el-breadcrumb {
  font-size: 12px;
  color: rgba(102, 102, 102, 1);
  line-height: 12px;
  float: left;
}
.dangqian {
  float: left;
}
/deep/.el-breadcrumb__inner {
  font-weight: 400 !important;
}
.red {
  color: #00345e;
}

.isActive {
  background: #fce9ea;
}
.left {
  width: 180px;
  height: 250px;
  background-color: white;
}
.smallBox {
  width: 180px;
  height: 52px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 52px;
  text-align: center;
}
.top {
  margin-top: 24px;
  width: 180px;
  height: 52px;
  line-height: 52px;
  background-color: #00345e;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  display: flex;
  justify-content: flex-start;
}
.yi {
  margin-left: 10px;
  font-size: 16px;
  line-height: 50px;
  color: white;
}
.right {
  margin-left: 20px;
  width: 1000px;
  min-height: 712px;
  background-color: white;
  padding: 41px 40px;
  box-sizing: border-box;
}
i {
  margin-left: 10px;
  width: 18px;
  height: 18px;
  color: white;
}
/deep/.router-link-active {
  display: block;
  width: 134px;
  background: #00345e;
}

.textContent {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  margin-top: 100px;
}

.text {
  display: block;
  text-align: center;
  margin: 20px auto;
  font-weight: 800;
  font-size: 20px;
  color: aqua;
}
</style>
